import React from 'react';
import Navbar from './Components/Navbar/Navbar';
import {Routes, Route} from 'react-router-dom';
import HomePage from './Routing/HomePage';
import Footer from './Components/Footer/Footer';
import AboutPage from './Routing/AboutPage';
import ServicePage from './Routing/ServicePage';
import ProjectPage from './Routing/ProjectPage';
import ProjectDynamic from './Routing/ProjectDynamic';
import ServiceDynamic from './Routing/ServiceDynamic';
import ContactPage from './Routing/ContactPage';
import ScrollToTop from './Components/ScrollToTop';
import WhatsAppButton from './Components/WhatsAppButton/WhatsAppButton';
import SectorPage from './Routing/SectorPage';

function App() {
  
  return (
    <>

    <ScrollToTop />

      <Navbar />
      <Routes>
        <Route path="/our-projects/project/:id" element={<ProjectDynamic />} />
         <Route path="/" element={<HomePage />} />
         <Route path="/about-us" element={<AboutPage />} />
         <Route path="/services" element={<ServicePage />} />
         <Route path="/our-sector" element={<SectorPage />} />
         <Route path="/services/service/:id" element={<ServiceDynamic />} />
         <Route path="/our-projects" element={<ProjectPage />} />
         <Route path="/project/:id" element={<ProjectPage />} />
         <Route path="/contact-us" element={<ContactPage />} />
      </Routes>

      <WhatsAppButton />

      <Footer />
    </>
  );
}

export default App;
